module.exports = __webpack_public_path__ + "img/small-4.0a1e793c.jpg";